"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Block = void 0;
const PIXI = __importStar(require("pixi.js"));
const object_1 = require("@/simulator/object");
const colors_1 = require("@/simulator/render/colors");
const vector_1 = require("@/simulator/vector");
const convexHitbox_1 = require("@/simulator/hitboxes/convexHitbox");
const i18n_1 = require("@/common/i18n");
const ball_1 = require("./ball");
class Block extends object_1.CanvasObject {
    constructor(render, x, y, mass = 1, velocity = vector_1.Vector.Zero, size = 30) {
        super(render, new PIXI.Graphics()
            .rect(0, 0, size, size)
            .fill(colors_1.colors["wood"]), mass, velocity, new convexHitbox_1.ConvexHitbox(size, size, { x: x - size / 2, y: y - size / 2 }));
        this.size = size;
        this.obj.position.set(x, y);
        this._enableInteractivity();
        this._enableSettings(ball_1.Ball.id, () => ({
            name: {
                name: (0, i18n_1.$)("modal.object.block.name"),
                value: this.name,
                controlOptions: {
                    type: "text",
                    maxLength: 1
                }
            },
            mass: {
                name: (0, i18n_1.$)("modal.object.block.mass"),
                description: "m / kg",
                value: this.mass,
                controlOptions: {
                    type: "number",
                    minValue: 0
                }
            }
        }));
        this.applyGravity();
        this._register(this.hitbox.onHit(({ obj, overlayX, overlayY }) => {
            if (obj instanceof Block || obj instanceof ball_1.Ball) {
                obj.hitbox.cancelNextTest();
                /**
                 * To prevent objects from going through each other
                 */
                // Test which side the hit happens (left right side / top side)
                if (Math.abs(overlayX) < Math.abs(overlayY) && overlayX !== 0) {
                    this.obj.x -= overlayX / 2;
                    obj.obj.x += overlayX / 2;
                }
                else {
                    this.obj.y -= overlayY / 2;
                    obj.obj.y += overlayY / 2;
                }
                this.updateHitboxAnchor();
                obj.updateHitboxAnchor();
                /**
                 * Calculate new velocities (elastic collision)
                 *
                 * v1' = ((m1 - m2) * v1) / (m1 + m2) + (2 * m2 * v2) / (m1 + m2)
                 * v2' = ((m2 - m1) * v2) / (m1 + m2) + (2 * m1 * v1) / (m1 + m2)
                 */
                /** *m1 + m2* */
                const massSum = this.mass + obj.mass;
                /** *m1 - m2* */
                const massDiff = this.mass - obj.mass;
                const vx1 = this.velocity.getComponent(new vector_1.Vector(1, 0));
                const vy1 = this.velocity.getComponent(new vector_1.Vector(0, 1));
                const vx2 = obj.velocity.getComponent(new vector_1.Vector(1, 0));
                const vy2 = obj.velocity.getComponent(new vector_1.Vector(0, 1));
                // X direction
                /** *((m2 - m1) v2) / (m1 + m2)* */
                const vxa = vector_1.Vector.multiplyScalar(vx2, -massDiff / massSum);
                /** *(2 m1 v1) / (m1 + m2)* */
                const vxb = vector_1.Vector.multiplyScalar(vx1, (2 * this.mass) / massSum);
                /** *((m1 - m2) v1) / (m1 + m2)* */
                const vxc = vector_1.Vector.multiplyScalar(vx1, massDiff / massSum);
                /** *(2 m2 v2) / (m1 + m2)* */
                const vxd = vector_1.Vector.multiplyScalar(vx2, (2 * obj.mass) / massSum);
                // Y direction
                /** *((m2 - m1) v2) / (m1 + m2)* */
                const vya = vector_1.Vector.multiplyScalar(vy2, -massDiff / massSum);
                /** *(2 m1 v1) / (m1 + m2)* */
                const vyb = vector_1.Vector.multiplyScalar(vy1, (2 * this.mass) / massSum);
                /** *((m1 - m2) v1) / (m1 + m2)* */
                const vyc = vector_1.Vector.multiplyScalar(vy1, massDiff / massSum);
                /** *(2 m2 v2) / (m1 + m2)* */
                const vyd = vector_1.Vector.multiplyScalar(vy2, (2 * obj.mass) / massSum);
                obj.velocity = vector_1.Vector.add(vector_1.Vector.add(vxa, vxb), vector_1.Vector.add(vya, vyb)); // v2'
                this.velocity = vector_1.Vector.add(vector_1.Vector.add(vxc, vxd), vector_1.Vector.add(vyc, vyd)); // v1'
            }
        }));
        this._register(this.onPointerUp(({ velocity }) => {
            this.velocity = velocity;
        }));
        this._register(this.onSettingsSave((settings) => {
            this.setName(settings["name"].value);
            this.setMass(settings["mass"].value);
        }));
    }
    update(delta) {
        super.update(delta);
        this._drawName(this.size / 2, this.size / 2);
    }
}
exports.Block = Block;
Block.id = "block";
(0, object_1.registerObject)(Block.id, Block);
